import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import * as fileService from '../admin/services/fileService';
import Swal from 'sweetalert2';
import { MobileContext } from '../contexts/MobileContext';
import { ParameterContext } from '../contexts/ParameterContext';

export const SucceedRegistration = ({ user, regId }) => {
    const [loading, setLoading] = useState(false)
    const { isOnMobile } = useContext(MobileContext);
    const { parameters } = useContext(ParameterContext);

    let hideParentLogin;

    if (parameters && parameters.nomParameters) {
        const hideParentLoginParam = parameters.nomParameters.find(x => x.param_name == 'HIDE_PARENT_LOGIN');
        hideParentLogin = hideParentLoginParam ? hideParentLoginParam.value : 0;
    } else {
        hideParentLogin = 0;
    }

    const getdataPDF = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            let downloadUrl = await fileService.getApplicationPDF({ regId });

            if (downloadUrl) {
                if (isOnMobile) {
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = 'document.pdf';
                    link.click();
                } else {
                    const newTab = window.open(downloadUrl, '_blank');
                    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                        console.error('Error: The browser blocked opening a new tab.');
                        Swal.fire({
                            title: 'Браузърът блокира отварянето на PDF файла.',
                            text: 'Проверете настройките на браузъра си за поверителност и сигурност(Privacy & Security.),за Chrome: Изскач. прозорци и пренасочвания(Pop-ups and Redirects), за Mozilla: Разрешения(Permissions)',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })
                    }
                }
            }
            setLoading(false);

        } catch (error) {
            console.error('Error fetching PDF:', error);
        }
    };

    return (
        <div className="children_data">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <div className="title_entr text-success">Регистрацията на заявлението е успешна</div>
            <div className="htext text-center">Вашият номер на регистрираното заявление е <b>{regId}</b></div>
            <p className="text-md-center">
                {`За да видите вашето заявление трябва да `}
                {user.role === 'Parent' ? (
                    <>
                        навигирате до <Link to="/parent">НАЧАЛО</Link>
                    </>
                ) : user.role == 'Director' ? (
                    <>
                        натиснете <button className="btn-link" onClick={getdataPDF}>тук</button>
                    </>)
                    : (
                        <>
                                влезете в системата от <Link to={hideParentLogin != 0 ? `/${hideParentLogin}` : "/parent-login" }>тук</Link>
                        </>
                    )}
            </p>
        </div>
    )
}